module.exports = __webpack_public_path__ + "img/logo-cotizacion.f521ac2a.png";